import axios from "services/axios";
import {useMutation, useQueryClient} from "react-query";

export function useAddDoctorPrice(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(values => axios.post("admin/doctor-prices", values).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries("doctor-prices");
			queryClient.removeQueries("doctor-prices");
		},
	});
}
export function useEditDoctorPrice(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.put(`admin/doctor-prices/${formData.id}`, formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries("doctor-prices");
			queryClient.removeQueries("doctor-prices");
		},
	});
}

export function useDeleteDoctorPrice(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.post("admin/doctor-prices/delete", formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries("doctor-prices");
			queryClient.removeQueries("doctor-prices");
		},
	});
}

export function useBulkDeleteDoctorPrice(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(
		formData =>
			axios
				.post(`admin/doctor-prices/doctor/${formData?.doctorUserId}/hospital/${formData?.hospitalId}`)
				.then(res => res.data),
		{
			onSuccess: () => {
				queryClient.invalidateQueries("doctor-prices");
				queryClient.removeQueries("doctor-prices");
			},
		},
	);
}

export function useApproveDoctorPrice() {
	const queryClient = useQueryClient();

	return useMutation(
		formData => axios.post(`admin/doctor-prices/${formData.id}/approve`, formData).then(res => res.data),
		{
			onSuccess: () => {
				queryClient.invalidateQueries("doctor-prices");
				queryClient.removeQueries("doctor-prices");
			},
		},
	);
}

export function useRejectDoctorPrice() {
	const queryClient = useQueryClient();

	return useMutation(
		formData => axios.post(`admin/doctor-prices/${formData.id}/reject`, formData).then(res => res.data),
		{
			onSuccess: () => {
				queryClient.invalidateQueries("doctor-prices");
				queryClient.removeQueries("doctor-prices");
			},
		},
	);
}

export function useSendOtpDoctorPrice() {
	return useMutation(formData => axios.post(`admin/doctor-prices/send-otp`, formData).then(res => res.data));
}

export function useValidateOtpDoctorPrice() {
	return useMutation(formData => axios.post(`admin/doctor-prices/validate-otp`, formData).then(res => res.data));
}
